import type { SelectItem } from "./types";

export function itemToString(item: SelectItem | null) {
  return item ? item.title : "";
}
